import * as React from 'react'
import {joinStrings} from "../lib/utils"

interface Props {
	message?:string // Default is "Loading…"
	className?:string
}

export const Loading = (props:Props) =>
	<div className={joinStrings(props.className ? ['loading', props.className] : ['loading'])}>
		<div className="icon">
			<img src="/sb/static/images/loadergif.gif" />
		</div>
		<div className="message">
			{props.message == null ? "Loading…" : props.message}
		</div>
	</div>



// WEBPACK FOOTER //
// ./src/react-components/Loading.tsx